import { Link } from 'react-router-dom'
import { MainNav } from './Navigation'
import { ThemeToggle } from "@/components/theme/theme-toggle"

export function Header() {
  return (
    <header className="border-b">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <nav className="flex items-center space-x-8">
            <Link to="/" className="font-bold text-xl">
              Polymath
            </Link>
            <MainNav />
          </nav>
          <ThemeToggle />
        </div>
      </div>
    </header>
  )
} 